module.exports = __webpack_public_path__ + "static/cutie-guitar-8ae45746b6962644e264f0eddd5a8764.jpg";